import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Link } from "react-router-dom";

import config from './../config';

class DropdownList extends Component {
	constructor(props) {
		super(props);

		this.documentMouseDownHandler = this.documentMouseDownHandler.bind(this);

		this.state = {
			open: false
		};
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.documentMouseDownHandler);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.documentMouseDownHandler);
	}

	documentMouseDownHandler(event) {
		var componentEl = ReactDOM.findDOMNode(this.refs.container);

		if (componentEl && !componentEl.contains(event.target)) {	
			this.setState({
				open: false
			});
		}
	}

	render() {
		return (
			this.props.listData ?
			<div ref="container" className={'dropdown'+(this.state.open ? ' show' : '')}>
				<button className="btn btn-primary dropdown-toggle" type="button" onClick={function() {
					this.setState({
						open: !this.state.open
					})
				}.bind(this)}>
					{this.props.label || ''}
				</button>
				<div className={'dropdown-menu'+(this.state.open ? ' show' : '')}>
					{
						this.props.listData.map(function(item, index) {
							return <Link to={this.props.linkFormatFunc ? this.props.linkFormatFunc(item) : ''} 
								key={index} 
								className={'dropdown-item'+(this.props.selectedItem && this.props.valueField && this.props.selectedItem == item[this.props.valueField] ? ' active' : '')} 
								data-value={item[this.props.valueField]}
								onClick={function() {
									this.setState({
										open: false
									});
								}.bind(this)}>
									{this.props.labelFunc ? this.props.labelFunc(item) : item[this.props.labelField]}
							</Link>;
						}.bind(this))
					}
				</div>
			</div>
			: null
		);
	}
}

export default DropdownList;



// WEBPACK FOOTER //
// ./src/components/DropdownList.js